// Interaction States
export const DRAWING = 'drawing';
export const TUTORIAL = 'tutorial';
export const EXPORT = 'export';
export const PREVIEW = 'preview';
export const NEW = 'new';
